export * from "./httpService/HttpService";
export * from "./token/index";

export const constants = {
  landingPageUrl: "app.acciojob.com",
};
